(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() { this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
    createObserver() { let observer = new IntersectionObserver((entries, observer) => { this.headerBounds = entries[0].intersectionRect; observer.disconnect(); }); observer.observe(this.header); }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) { this.header.classList.add('scrolled-past-header'); if (this.preventHide) return; requestAnimationFrame(this.hide.bind(this)); }
      else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) { this.header.classList.add('scrolled-past-header'); if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); } else { window.clearTimeout(this.isScrolling); this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66); requestAnimationFrame(this.hide.bind(this)); } }
      else if (scrollTop <= this.headerBounds.top) { this.header.classList.remove('scrolled-past-header'); requestAnimationFrame(this.reset.bind(this)); }
      this.currentScrollTop = scrollTop;
    }
    hide() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
    reveal() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset() { if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
    closeMenuDisclosure() { this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach((disclosure) => disclosure.close()); }
    closeSearchModal() { this.searchModal = this.searchModal || this.header.querySelector('details-modal'); if (this.searchModal) this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvy-banner-grid"] && !Shopify.designMode) return;
  try {
    
(function(){document.querySelectorAll('[data-copy-code]').forEach(function(b){b.addEventListener('click',function(){var c=b.getAttribute('data-copy-code'),t=b.querySelector('.savvy-bgrid__copy-txt');if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(c).then(function(){if(t){t.textContent='Copied!';setTimeout(function(){t.textContent='Copy Code'},2000)}})}else{var a=document.createElement('textarea');a.value=c;a.style.position='fixed';a.style.left='-9999px';document.body.appendChild(a);a.select();try{document.execCommand('copy');if(t){t.textContent='Copied!';setTimeout(function(){t.textContent='Copy Code'},2000)}}catch(e){}document.body.removeChild(a)}})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvy-collections-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var secciones = document.querySelectorAll('.savvy-colecciones');

    secciones.forEach(function(seccion) {
      var pista = seccion.querySelector('.savvy-colecciones__pista');
      var flechas = seccion.querySelectorAll('.savvy-colecciones__flecha');
      var puntos = seccion.querySelectorAll('.savvy-colecciones__punto');
      var cards = seccion.querySelectorAll('.savvy-colecciones__card');

      if (!pista || cards.length === 0) return;

      function getVisibleCount() {
        var w = window.innerWidth;
        if (w >= 990) return 4;
        if (w >= 750) return 2;
        return 1;
      }

      function getCurrentIndex() {
        var scrollLeft = pista.scrollLeft;
        var cardWidth = cards[0].offsetWidth;
        var gap = parseInt(getComputedStyle(pista).gap) || 12;
        return Math.round(scrollLeft / (cardWidth + gap));
      }

      function actualizarPuntos(idx) {
        puntos.forEach(function(p, i) {
          p.classList.toggle('savvy-colecciones__punto--activo', i === idx);
        });
      }

      function actualizarFlechas() {
        var izq = seccion.querySelector('.savvy-colecciones__flecha--izq');
        var der = seccion.querySelector('.savvy-colecciones__flecha--der');
        if (!izq || !der) return;

        var scrollLeft = pista.scrollLeft;
        var maxScroll = pista.scrollWidth - pista.clientWidth;

        izq.style.opacity = scrollLeft <= 5 ? '0.3' : '1';
        izq.style.pointerEvents = scrollLeft <= 5 ? 'none' : 'auto';
        der.style.opacity = scrollLeft >= maxScroll - 5 ? '0.3' : '1';
        der.style.pointerEvents = scrollLeft >= maxScroll - 5 ? 'none' : 'auto';
      }

      flechas.forEach(function(flecha) {
        flecha.addEventListener('click', function() {
          var dir = this.getAttribute('data-dir');
          var cardWidth = cards[0].offsetWidth;
          var gap = parseInt(getComputedStyle(pista).gap) || 12;
          var visibles = getVisibleCount();
          var scrollAmount = (cardWidth + gap) * visibles;

          pista.scrollBy({
            left: dir === 'next' ? scrollAmount : -scrollAmount,
            behavior: 'smooth'
          });
        });
      });

      var scrollTimeout;
      pista.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          actualizarPuntos(getCurrentIndex());
          actualizarFlechas();
        }, 80);
      });

      actualizarFlechas();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvy-product-tabs"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.savvy-ptabs').forEach(function(section){
    var tabs=section.querySelectorAll('[data-tab-index]');
    var panels=section.querySelectorAll('[data-panel-index]');
    tabs.forEach(function(tab){
      tab.addEventListener('click',function(){
        var idx=tab.getAttribute('data-tab-index');
        tabs.forEach(function(t){t.classList.remove('savvy-ptabs__tab--activo');t.setAttribute('aria-selected','false')});
        panels.forEach(function(p){p.classList.remove('savvy-ptabs__panel--activo');p.setAttribute('hidden','')});
        tab.classList.add('savvy-ptabs__tab--activo');
        tab.setAttribute('aria-selected','true');
        var panel=section.querySelector('[data-panel-index="'+idx+'"]');
        if(panel){panel.classList.add('savvy-ptabs__panel--activo');panel.removeAttribute('hidden')}
      });
    });
    var prevBtn=section.querySelector('[data-slider-prev]');
    var nextBtn=section.querySelector('[data-slider-next]');
    function getActiveSlider(){var ap=section.querySelector('.savvy-ptabs__panel--activo');return ap?ap.querySelector('.savvy-ptabs__slider'):null}
    if(prevBtn)prevBtn.addEventListener('click',function(){var s=getActiveSlider();if(s)s.scrollBy({left:-240,behavior:'smooth'})});
    if(nextBtn)nextBtn.addEventListener('click',function(){var s=getActiveSlider();if(s)s.scrollBy({left:240,behavior:'smooth'})});
  });
  document.querySelectorAll('.savvy-ptabs__card-form').forEach(function(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=form.querySelector('.savvy-ptabs__card-atc');
      if(btn.classList.contains('savvy-ptabs__card-atc--adding'))return;
      btn.classList.add('savvy-ptabs__card-atc--adding');
      var origHTML=btn.innerHTML;
      btn.innerHTML='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10" stroke-dasharray="31" stroke-dashoffset="31"><animate attributeName="stroke-dashoffset" from="31" to="0" dur="0.6s" fill="freeze"/></circle></svg>';
      var fd={id:parseInt(form.querySelector('input[name="id"]').value),quantity:parseInt(form.querySelector('input[name="quantity"]').value),sections:'cart-drawer,cart-icon-bubble'};
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(fd)})
      .then(function(r){return r.json()})
      .then(function(data){
        var cd=document.querySelector('cart-drawer');
        if(cd&&typeof cd.renderContents==='function'&&data.sections){cd.renderContents(data)}
        else{var b=document.getElementById('cart-icon-bubble');if(data.sections&&data.sections['cart-icon-bubble']&&b){b.innerHTML=new DOMParser().parseFromString(data.sections['cart-icon-bubble'],'text/html').querySelector('.shopify-section').innerHTML}}
        btn.classList.remove('savvy-ptabs__card-atc--adding');
        btn.classList.add('savvy-ptabs__card-atc--added');
        btn.innerHTML='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
        setTimeout(function(){btn.innerHTML=origHTML;btn.classList.remove('savvy-ptabs__card-atc--added')},1500);
      })
      .catch(function(){
        btn.classList.remove('savvy-ptabs__card-atc--adding');
        btn.innerHTML='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
        setTimeout(function(){btn.innerHTML=origHTML},2000);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
